import React, {ReactElement} from "react";
import classNames from "classnames";

import {DummyBox} from "../Dummy/DummyBox";
import {Tooltip} from "../Tooltip";

import "./ProfileIcon.css";

export interface ProfileIconProps {
    className?: string;
    avatarSize: number;
    isReady: boolean;
    tooltipTitle: string;
    avatar: ReactElement | null;
    onClick: (event: React.MouseEvent<HTMLElement>) => void;
}

export const ProfileIcon = ({
    className,
    avatarSize,
    isReady,
    tooltipTitle,
    avatar,
    onClick,
}: ProfileIconProps) => {
    return (
        <div
            className={classNames("ProfileIcon", {
                [className!]: className,
            })}
            onClick={onClick}
        >
            {!isReady ? (
                <DummyBox
                    type="circle"
                    width={`${avatarSize}px`}
                    height={`${avatarSize}px`}
                />
            ) : avatar ? (
                <Tooltip
                    title={tooltipTitle}
                    menuPlacement="block-end"
                    menuAlignment="end"
                >
                    {avatar}
                </Tooltip>
            ) : null}
        </div>
    );
};
